import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionCard = ({ transaction, onClick }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success/10 text-success';
      case 'pending':
        return 'bg-warning/10 text-warning';
      case 'failed':
        return 'bg-error/10 text-error';
      case 'processing':
        return 'bg-primary/10 text-primary';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'payment':
        return 'ArrowDownLeft';
      case 'withdrawal':
        return 'ArrowUpRight';
      case 'commission':
        return 'Percent';
      case 'refund':
        return 'RotateCcw';
      default:
        return 'DollarSign';
    }
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    })?.format(amount);
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })?.format(new Date(date));
  };

  return (
    <button
      onClick={() => onClick(transaction)}
      className="w-full p-4 bg-card border border-border rounded-lg hover:shadow-elevation-2 transition-smooth text-left"
    >
      <div className="flex items-start gap-4">
        <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
          transaction?.type === 'payment' ? 'bg-success/10' :
          transaction?.type === 'withdrawal' ? 'bg-primary/10' :
          transaction?.type === 'commission'? 'bg-accent/10' : 'bg-muted'
        }`}>
          <Icon 
            name={getTypeIcon(transaction?.type)} 
            size={20}
            color={
              transaction?.type === 'payment' ? 'var(--color-success)' :
              transaction?.type === 'withdrawal' ? 'var(--color-primary)' :
              transaction?.type === 'commission' ? 'var(--color-accent)' :
              'var(--color-muted-foreground)'
            }
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1">
            <h3 className="font-semibold text-foreground truncate">{transaction?.description}</h3>
            <span className={`font-bold whitespace-nowrap ${
              transaction?.type === 'payment' || transaction?.type === 'refund' ?'text-success' :'text-foreground'
            }`}>
              {transaction?.type === 'payment' || transaction?.type === 'refund' ? '+' : '-'}
              {formatAmount(transaction?.amount)}
            </span>
          </div>

          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm text-muted-foreground">{transaction?.reference}</span>
            <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(transaction?.status)}`}>
              {transaction?.status === 'completed' ? 'Tamamlandı' :
               transaction?.status === 'pending' ? 'Beklemede' :
               transaction?.status === 'failed' ? 'Başarısız' :
               transaction?.status === 'processing' ? 'İşleniyor' : transaction?.status}
            </span>
          </div>

          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            <span className="flex items-center gap-1">
              <Icon name="Calendar" size={12} />
              {formatDate(transaction?.date)}
            </span>
            {transaction?.commission && (
              <span className="flex items-center gap-1">
                <Icon name="Percent" size={12} />
                Komisyon: {formatAmount(transaction?.commission)}
              </span>
            )}
          </div>
        </div>
      </div>
    </button>
  );
};

export default TransactionCard;